import { render, staticRenderFns } from "./TextArrayView.vue?vue&type=template&id=3bf5a47e&scoped=true&"
import script from "./TextArrayView.vue?vue&type=script&lang=js&"
export * from "./TextArrayView.vue?vue&type=script&lang=js&"
import style0 from "./TextArrayView.vue?vue&type=style&index=0&id=3bf5a47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5a47e",
  null
  
)

export default component.exports